import React, { ChangeEvent, FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import PrincipalDBTable from "./PrincipalDBTable";
import FilterSection from "./components/FilterSection";
import Pagination from "../../components/Pagination";
import {
  resetAll,
  selectData,
  selectError,
  selectIsFetching,
  selectPage,
  selectPages,
  selectSort,
  updatePagination,
  updateSort,
} from "../../store/principal";
import { TableHeaderSort } from "../../components/Table/components/TableHeader/types";
import Message from "../../components/Table/components/Message";
import { ContentLoaderContainer } from "../../components/Loader/ContentLoader/ContentLoaderContainer";
import { principalDatabaseView } from "../../config/router/routes";

export const PrincipalDB: FC = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector(selectPage);
  const pages = useSelector(selectPages);
  const defaultSort = useSelector(selectSort);
  const data = useSelector(selectData);
  const isFetching = useSelector(selectIsFetching);
  const error = useSelector(selectError);
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    return () => {
      dispatch(resetAll());
    };
  }, [dispatch]);

  const handlePageSizeChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const pageSize = parseInt(event.currentTarget.value);

    dispatch(updatePagination({ pageSize, page: 0 }));
  };

  const handlePageChange = (page: number) => {
    dispatch(updatePagination({ page }));
  };

  const handleSort = (sort: TableHeaderSort) => {
    dispatch(updateSort(sort));
  };

  const handleClick = (rowData: any) => {
    history.push(principalDatabaseView.path.replace(":id", rowData.id));
  };

  return (
    <>
      <h1>{t("principalDatabase")}</h1>
      <div className="mb-m">
        <FilterSection />
      </div>
      {isFetching ? (
        <ContentLoaderContainer />
      ) : error || !data.length ? (
        <Message>{t("nothingToDisplay")}</Message>
      ) : (
        <PrincipalDBTable
          data={data}
          defaultSort={defaultSort}
          onSort={handleSort}
          onDoubleClick={handleClick}
        />
      )}
      <Pagination
        page={currentPage}
        pages={pages}
        onPageSizeChange={handlePageSizeChange}
        onPageChange={handlePageChange}
      />
    </>
  );
};
